<div class="create-order__main-content">
    <div class="import-select__content">
        <div class="select-to-import-option">
            <label class="select-lbl">Form</label>
            <cv-dropdown
                    [options]="formList$ | async"
                    [placeholder]="'Select a form'"
                    [optionText]="'displayText'"
                    [width]="'100%'"
                    (valuesChange)="onFormSelectChange($event)"
            ></cv-dropdown>
        </div>
    </div>
    <cv-drag-and-drop-file [message]="filesDropMessage" (filesDropped)="onFilesDropped($event)"></cv-drag-and-drop-file>
    <div class="import-select__content">
        <div class="import-option__btn">
            <button
                    [disabled]="createOrderForm.form === null || createOrderForm.file === null"
                    class="btn btn-sm btn-primary"
                    (click)="onSubmitOrder()"> Submit order <i class="fas fa-upload"></i>
            </button>
        </div>
    </div>
</div>
